import { toCSSPixel } from '../../../utils/styles'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../Checkbox'

import * as styles from './TableRowActions.module.css'

function TableRowActions({
  className = styles.TableRowActions,
  disabled,
  size = CHECKBOX_SIZE.small,
  type = CHECKBOX_TYPE.tableRow,
  width,
  ...restProps
}) {
  return (
    <div className={className} style={{ width: toCSSPixel(width) }}>
      <Checkbox {...restProps} disabled={disabled} size={size} type={type} />
    </div>
  )
}

export default TableRowActions
